// extracted by mini-css-extract-plugin
export default {"container":"SearchPanel_container__bUvrC","content":"SearchPanel_content__taMwt","searchIcon":"SearchPanel_searchIcon__dOtwl","description":"SearchPanel_description__jCtG1"};